import { FamilyChildProfile } from "@joonapp/web-shared"

import useSelectedFamilyMember from "./useSelectedFamilyMember"

export const useIsChildOnboarded = () => {
  const { selectedProfile } = useSelectedFamilyMember()
  return (
    (selectedProfile as FamilyChildProfile | undefined)?.user.active_doter
      .date_hatched !== null
  )
}

export default useIsChildOnboarded
